import { render, staticRenderFns } from "./provincialProduction_page.vue?vue&type=template&id=bb10843a&scoped=true"
import script from "./provincialProduction_page.vue?vue&type=script&lang=js"
export * from "./provincialProduction_page.vue?vue&type=script&lang=js"
import style0 from "./provincialProduction_page.vue?vue&type=style&index=0&id=bb10843a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb10843a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb10843a')) {
      api.createRecord('bb10843a', component.options)
    } else {
      api.reload('bb10843a', component.options)
    }
    module.hot.accept("./provincialProduction_page.vue?vue&type=template&id=bb10843a&scoped=true", function () {
      api.rerender('bb10843a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/provincialProduction_page.vue"
export default component.exports